import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getTabsByPath } from "../utils/moduleAccessUtils.js";
import { useLoginUser } from "./useLoginUser.js";
import { getItem } from "../utils/localStorageUtils.js";

export const useModuleAccess = ({ allTabs, parentId, accessKey = "ats" }) => {
  const { moduleAccess } = useSelector((state) => state.auth);
  const { userData: loginUserData } = useLoginUser();
  const portal = getItem("portal");
  const filteredTabs = useMemo(() => {
    if (!moduleAccess || !allTabs) return [];
  // if (loginUserData?.role?.type === 1) {
  //   return allTabs;
  // }
    const role = loginUserData?.role?.type;
    const userModule = loginUserData?.role?.module;
    if (role === 1) {
      if (userModule === 1) return allTabs;
      const MODULE_PORTAL_MAP = {
        2: "ats",
        3: "wf",
        4: "bs",
      };
      const allowedPortal = MODULE_PORTAL_MAP[userModule];
      if (portal === allowedPortal) return allTabs;
      return [];
    }
    const allowedTabs = getTabsByPath({ moduleAccess, parentId, accessKey });
    const allowedNames = new Set(allowedTabs.map((tab) => tab.key));

    return allTabs.filter((tab) => allowedNames.has(tab.id));
  }, [moduleAccess, allTabs, parentId, accessKey]);

  return filteredTabs;
};
